import DataStore from "../DataStore";
import {makeEl} from "../../common/Utils";

export default class Copyright{
    private ds : DataStore;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        if(this.ds.config.copyright){
            this.templ(_wrapper, this.ds.config.copyright);
        }
    }

    templ(_parent: HTMLElement, _copyright: string){
        const tmpl = makeEl('div', _parent, {class: 'footer-copyright'});
        tmpl.innerHTML= _copyright;
    }
}